const productConcernSubstancesDescriptor = Object.freeze({
    type: 'product-concern-substances',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(StepItem):step-3-label',
    fallbackTitle: 'Product concern substances',
    defaultDescriptionKey: null,
    fallbackDescription: 'Review and confirm substances relevant to the requested regulations.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'request.legislations',
            'product.card',
            'product.hierarchy',
            'product.concern-substances',
            'product.component-concern-substances',
        ],
        writes: [
            'request.details',
            'product.card',
            'product.concern-substances',
            'product.component-concern-substances',
        ],
    },
    effects: {
        publishes: [
            'request.details.changed',
            'product.card.changed',
            'product.concern-substances.changed',
            'product.component-concern-substances.changed',
        ],
        observes: [
            'request.details.changed',
            'product.card.changed',
        ],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            compactView: { type: 'boolean', default: false },
            showProductWeight: { type: 'boolean', default: true },
            showProductWeightMessage: { type: 'boolean', default: true },
            showInformationOwnerSelection: { type: 'boolean', default: true },
        },
    },
    settingsUi: {
        compactView: { control: 'switch' },
        showProductWeight: { control: 'switch' },
        showProductWeightMessage: { control: 'switch' },
        showInformationOwnerSelection: { control: 'switch' },
    },
})

export { productConcernSubstancesDescriptor }
export default productConcernSubstancesDescriptor
